import React from "react";

/** Разбор текста: ссылки, #хэштеги, @mentions, переносы строк */
function tokenizeText(input) {
    if (!input) return [];
    const urlRe = /(https?:\/\/[^\s]+)/g;
    const tagRe = /(^|[\s])#[\p{L}\p{N}_]+/giu;
    const mentionRe = /(^|[\s])@[\p{L}\p{N}_.-]+/giu;

    const parts = [];
    const lines = input.split(/\n/);
    lines.forEach((line, idx) => {
        let cursor = 0;
        const urls = [...line.matchAll(urlRe)];

        const pushText = (text) => text && parts.push({ type: "text", value: text });

        const pushStyled = (segment) => {
            let last = 0;
            const re = new RegExp(`${tagRe.source}|${mentionRe.source}`, "giu");
            const matches = [...segment.matchAll(re)];
            matches.forEach((m) => {
                const start = m.index ?? 0;
                if (start > last) pushText(segment.slice(last, start));
                const val = m[0];
                if (val.trim().startsWith("#")) parts.push({ type: "tag", value: val });
                else parts.push({ type: "mention", value: val });
                last = start + val.length;
            });
            if (last < segment.length) pushText(segment.slice(last));
        };

        if (urls.length === 0) {
            pushStyled(line);
        } else {
            urls.forEach((m) => {
                const start = m.index ?? 0;
                if (start > cursor) pushStyled(line.slice(cursor, start));
                parts.push({ type: "url", value: m[0] });
                cursor = start + m[0].length;
            });
            if (cursor < line.length) pushStyled(line.slice(cursor));
        }
        if (idx < lines.length - 1) parts.push({ type: "newline", value: "\n" });
    });
    return parts;
}

export default function TextRenderer({ text, clampChars }) {
    const tokens = React.useMemo(() => tokenizeText(text || ""), [text]);
    const rendered = [];
    let total = 0;
    const limit = clampChars ?? Infinity;

    const emit = (node, len, raw) => {
        if (total >= limit) return;
        if (total + len > limit) {
            const rest = limit - total;
            if (raw && rest > 0) rendered.push(<span key={rendered.length}>{raw.slice(0, rest)}…</span>);
            total = limit;
            return;
        }
        rendered.push(<React.Fragment key={rendered.length}>{node}</React.Fragment>);
        total += len;
    };

    for (let i = 0; i < tokens.length; i++) {
        const t = tokens[i];

        if (t.type === "newline") {
            const remaining = limit - total;
            if (remaining <= 0) continue;

            // проверяем: есть ли ещё видимые токены дальше
            let willRenderMore = false;
            for (let j = i + 1; j < tokens.length; j++) {
                const nt = tokens[j];
                if (nt.type === "newline") continue;
                const len = (nt.value || "").length;
                if (len > 0) { willRenderMore = true; break; }
            }
            if (willRenderMore) {
                rendered.push(<br key={rendered.length} />);
            }
            continue;
        }

        if (t.type === "text") emit(<span>{t.value}</span>, t.value.length, t.value);
        if (t.type === "url") emit(<a href={t.value} target="_blank" rel="noreferrer">{t.value}</a>, t.value.length, t.value);
        if (t.type === "tag") emit(<span style={{ color: "#1677ff" }}>{t.value}</span>, t.value.length, t.value);
        if (t.type === "mention") emit(<span style={{ color: "#52c41a" }}>{t.value}</span>, t.value.length, t.value);
    }

    return <>{rendered}</>;
}
